module.exports = __webpack_public_path__ + "img/illu-table.688e5548.svg";